export default __webpack_public_path__ + "static/media/infobanner3.4a73a4a6.svg";